const firebaseConfig = {
  apiKey: "AIzaSyAhTLqdM95QLpan_b7Y132z7_ahRtn056E",
  authDomain: "fitness-zone-369cf.firebaseapp.com",
  projectId: "fitness-zone-369cf",
  storageBucket: "fitness-zone-369cf.appspot.com",
  messagingSenderId: "237727164640",
  appId: "1:237727164640:web:4bcc1cd25cd952682b4885"
};

export default firebaseConfig;